import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Grid, Box, Menu } from '@mui/material';

import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ApiIcon from '@mui/icons-material/Api';
import DataObjectIcon from '@mui/icons-material/DataObject';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';

import { COLOR_PRIMARY_DARK, COLOR_BLACK } from 'src/const';
import { KPI_CARD_COLOR } from 'src/colors';
import { setLeadFormSource } from 'src/store/Dashboard/actions';
import NestedMenuItem from 'src/App/Components/NestedMenuItem';

const MenuIconStyle = {
  color: COLOR_BLACK,
  paddingRight: '5px',
};

const HelpMenu = ({
  handleMarketSidebarClick,
  handleSidebarListItemClick,
  openDemoBookingForm,
  setDemoFormHeadingFor,
}) => {
  const dispatch = useDispatch();

  const [helperEl, setHelperEl] = useState(null);
  const [enterpriseDropDownOpen, setEnterpriseDropDownOpen] = useState(false);

  const handleHelperClick = ({ currentTarget }) => {
    setHelperEl(currentTarget);
  };
  const handleHelperClose = () => {
    setHelperEl(null);
  };

  const handleEnterpriseDropdownClick = () => {
    setEnterpriseDropDownOpen(!enterpriseDropDownOpen);
  };

  const handleCustomDataBtnClick = () => {
    handleHelperClose();
    setEnterpriseDropDownOpen(false);
    setDemoFormHeadingFor('sales');
    openDemoBookingForm();
    dispatch(setLeadFormSource('app-header'));
  };

  const handleApiBtnClick = () => {
    setEnterpriseDropDownOpen(false);
    window.open('https://documenter.getpostman.com/view/25155751/2s9XxtyvNn', '_blank');
  };


  const openChat = () => {
    const tawkURL = 'https://tawk.to/chat/5f42ecee1e7ade5df4434438/default';
    const win = window.open(tawkURL, '_blank');
    win && win.focus();

    // the below code is not working anymore
    const _window: any = window;
    const Tawk_API = _window.Tawk_API || {};
    Tawk_API && Tawk_API.popup && Tawk_API.popup();
  };

  const opeFreeWebinar = () => {
    window.open('https://airbticsltd.ewebinar.com/webinar/airbtics-onboarding-16533');
  };

  const openFAQ = () => {
    window.open('https://support.airbtics.com/');
  };

  const helpMenuItems = [
    {
      title: 'Free Webinar',
      handleClick: opeFreeWebinar,
      icon: <OpenInNewRoundedIcon sx={MenuIconStyle} />,
    },
    {
      title: 'Support',
      handleClick: openChat,
      icon: <SupportAgentIcon sx={MenuIconStyle} />,
    },
    {
      title: 'FAQ',
      handleClick: openFAQ,
      icon: <QuestionAnswerIcon sx={MenuIconStyle} />,
    },    
    {
      title: 'Enterprise',
      handleClick: handleEnterpriseDropdownClick,
      icon: <BusinessRoundedIcon sx={MenuIconStyle} />,
      open: enterpriseDropDownOpen,
      children: [
        {
          title: 'Custom Data',
          handleClick: handleCustomDataBtnClick,
          icon: <DataObjectIcon sx={MenuIconStyle} />,
        },
        {
          title: 'API',
          handleClick: handleApiBtnClick,
          icon: <ApiIcon sx={MenuIconStyle} />,
        },
      ],
    },
  ];

  return (
    <Grid item>
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: 200,
          border: `4px solid ${COLOR_PRIMARY_DARK}`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <QuestionMarkRoundedIcon
          sx={{
            width: 30,
            height: 30,
            cursor: 'pointer',
            color: KPI_CARD_COLOR,
          }}
          onClick={handleHelperClick}
        />
      </Box>

      <Menu
        anchorEl={helperEl}
        open={Boolean(helperEl)}
        onClose={handleHelperClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '10px',
          },
        }}
      >
        {helpMenuItems.map(item => (
          <NestedMenuItem
            title={item.title}
            handleClick={item.handleClick}
            icon={item.icon}
            open={item.open}
            children={item.children}
          />
        ))}
      </Menu>
    </Grid>
  );
};

export default HelpMenu;
